import { RESET_NUEVO_TURNO, SET_NUEVO_TURNO } from "../../ActionTypes";

export const setNuevoTurno = (data) => (dispatch) => {
  dispatch({ type: SET_NUEVO_TURNO, payload: data });
};
export const resetNuevoTurno = () => (dispatch) => {
  dispatch({ type: RESET_NUEVO_TURNO});
};
